module.exports = __webpack_public_path__ + "img/Ai.7cfb05a6.png";